import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-four',
  templateUrl: './blog-four.component.html',
  styleUrls: ['./blog-four.component.scss']
})
export class BlogFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
